<p>contato works!</p>
<div>
    <h2>CONTATO</h2>
    <form (ngSubmit)="onSubmit()">
      <label for="nome">Nome:</label>
      <input type="text" id="nome" [(ngModel)]="nome" name="nome" required>
  
      <label for="email">E-mail:</label>
      <input type="email" id="email" [(ngModel)]="email" name="email" required>
  
      <button type="submit">Enviar</button>
    </form>
  </div>
  